









































































import Vue from "vue";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import HomePageRightComponent from "./HomePageRight.vue";
import HomePageLeftComponent from "./HomePageLeft.vue";
import HomePageCenterComponent from "./HomePageCenter.vue";
import { State, Action, Getter } from "vuex-class";
import AuthService from "@/services/auth.service";
const auth = new AuthService();
const namespace: string = "RootApp";

@Component({
  components: {
    HomePageRightComponent,
    HomePageLeftComponent,
    HomePageCenterComponent,
  },
})
export default class HomePageComponent extends Vue {
  @Action("_appAbout", { namespace }) _appAbout: any;

  isAuthenticated: boolean = false;

  mounted() {
    auth.isLoggedIn().then((isLoggedIn: boolean) => {
      this.isAuthenticated = isLoggedIn;
    });
  }

  // Called by child component
  homePageleft(e) {
    //@ts-ignore
    this.$refs.form.homePageCenterFilter(e);
  }

  redirectToLogin() {
    this.$router.push("/gmsdashboard");
    localStorage.setItem('filterBy', '{}');
    localStorage.setItem('ddlChanged', '');
  }

}
